import React, { useEffect, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';


const QuotationView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);

    console.log(formData)
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };


    var sizes = formData?.size;
    // var percent = valueLoss / 100;
    // var percentProfit = profit / 100;
    var itemData = [
        {
            size: formData.size,
            avgM: formData.m0_avg ? formData.m0_avg : 0,
            avgM1: formData.m1_avg1 ? formData.m1_avg1 : 0,
            avgM2: formData.m2_avg2 ? formData.m2_avg2 : 0,
            avgM3: formData.m3_avg3 ? formData.m_avg3 : 0,
        }
    ];




    const renderTableRow = (size, index) => {
        const newAvgM = itemData.map((val) => val.avgM[index] || 0);
        const newAvgM1 = itemData.map((val) => val.avgM1[index] || 0);
        const newAvgM2 = itemData.map((val) => val.avgM2[index] || 0);
        const newAvgM3 = itemData.map((val) => val.avgM3[index] || 0);

        let m0rate = formData.m0rate ? formData.m0rate : 0;
        let m1rate = formData.m1rate ? formData.m1rate : 0;
        let m2rate = formData.m2rate ? formData.m2rate : 0;
        let m3rate = formData.m3rate ? formData.m3rate : 0;

        let outSrc = formData.outSrc ? parseFloat(formData.outSrc) : 0;

        let mCal = (parseFloat(m0rate) * outSrc / 100) + parseFloat(m0rate);
        let m1Cal = (parseFloat(m1rate) * outSrc / 100) + parseFloat(m1rate);
        let m2Cal = (parseFloat(m2rate) * outSrc / 100) + parseFloat(m2rate);
        let m3Cal = (parseFloat(m3rate) * outSrc / 100) + parseFloat(m3rate);

        // let fm0 = mCal * newAvgM / 100;
        // let fm1 = m1Cal * newAvgM1 / 100;
        // let fm2 = m2Cal * newAvgM2 / 100;
        // let fm3 = m3Cal * newAvgM3 / 100;

        let fm0 = mCal * parseFloat(newAvgM);
        let fm1 = m1Cal * parseFloat(newAvgM1);
        let fm2 = m2Cal * parseFloat(newAvgM2);
        let fm3 = m3Cal * parseFloat(newAvgM3);

        let clothrate = fm0 + fm1 + fm2 + fm3;
        let jobrate = formData.jobrate ? parseFloat(formData.jobrate) : 0;
        let calJob = Math.round(clothrate) + jobrate;


        let val_loss = formData.loss ? parseFloat(formData.loss) : 0;
        let cal_loss = calJob * val_loss / 100;
        let final_loss = Math.round(cal_loss + calJob);

        var extra = formData.extra ? parseFloat(formData.extra) : 0;
        let cost = Math.round(final_loss) + parseFloat(extra);
        let profit = cost * parseFloat(formData.profit) / 100;
        let finalRate = Math.round(profit + cost);

        let finalMrp1 = finalRate * 65 / 100;
        let finalMrp = Math.round(finalMrp1 + finalRate);

        return (
            <TableRow key={index}>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{size}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(fm0)}</TableCell>
                {formData.m1 && <>
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM1}</TableCell>
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(fm1)}</TableCell>
                </>
                }
                {formData.m2 &&
                    <>
                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM2}</TableCell>
                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(fm2)}</TableCell>
                    </>
                }
                {formData.m3 &&
                    <>
                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM3}</TableCell>
                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(fm3)}</TableCell>
                    </>
                }
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(clothrate)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(calJob)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(final_loss)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(cost)}</TableCell>
                {/* <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(profit)}</TableCell> */}
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(finalRate)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(finalMrp)}</TableCell>
            </TableRow>
        );
    };

    let mainrate = (parseFloat(formData.m0rate) * parseFloat(formData.outSrc) / 100) + parseFloat(formData.m0rate);

    let m1rate = (parseFloat(formData.m1rate) * parseFloat(formData.outSrc) / 100) + parseFloat(formData.m1rate);
    let m2rate = (parseFloat(formData.m2rate) * parseFloat(formData.outSrc) / 100) + parseFloat(formData.m2rate);
    let m3rate = (parseFloat(formData.m3rate) * parseFloat(formData.outSrc) / 100) + parseFloat(formData.m3rate);

    return (
        <>
            <div style={{ margin: '1% 0%', width: '100%' }}>

                <h3 className='centered-heading'>Quotation View</h3>
                <div className="dashed-line"></div>

                <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                    <tbody>

                        <tr>
                            <td style={{ width: '200px' }}>Item Name</td>
                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                            <td style={{ width: '200px', paddingLeft: '2%' }}>Job Rate</td>
                            <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.jobrate}</td>
                        </tr>

                        <tr>
                            <td style={{ width: '200px' }}>Firm Name</td>
                            <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.firmNm}</td>
                            <td style={{ width: '200px', paddingLeft: '2%' }}>Extra</td>
                            <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.extra}</td>
                        </tr>

                        <tr>
                            <td style={{ width: '200px' }}>Profit (%)</td>
                            <td style={{ width: '25vw', padding: ' 0 1.5%' }} className='dark-color'>{formData.profit}</td>
                            <td style={{ width: '200px', paddingLeft: '2%' }}>Value of Loss (%)</td>
                            <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.loss}</td>
                        </tr>

                        <tr>
                            <td style={{ width: '200px' }}>Main Cloth + OutSource {formData.outSrc} %</td>
                            <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.m0clothNm} <b>Panna: {formData.m0_panna}</b>  <b className='red-color'> Rate: {mainrate}</b></td>
                            {formData.m1 && (
                                <>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-1</td>
                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m1clothNm} <b>Panna: {formData.m1_panna}</b> <b className='red-color'> Rate: {m1rate}</b></td>
                                </>
                            )}
                        </tr>
                        <tr>
                            <td style={{ width: '200px' }}>Party</td>
                            <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.partyNm}</td>
                            {formData.m2 && (
                                <>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-2</td>
                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m2clothNm} <b>Panna: {formData.m2_panna}</b> <b className='red-color'> Rate: {m2rate}</b></td>
                                </>
                            )}
                        </tr>

                        <tr>
                            <td style={{ width: '200px' }}>School</td>
                            <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.schlNm}</td>
                            {formData.m3 && (
                                <>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-3</td>
                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m3clothNm} <b>Panna: {formData.m3_panna}</b> <b className='red-color'> Rate: {m3rate}</b></td>
                                </>
                            )}
                        </tr>


                    </tbody>
                </table>


                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                    <Table>
                        <TableHead>
                            <TableRow className='tbl-row'>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Main Avg.Mtr</TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{`Main Avg.Mtr Rate`} <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                {formData.m1 &&
                                    <>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M1 Avg.Mtr</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M1 Avg.Mtr Rate <br /> + <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                    </>
                                }
                                {formData.m2 &&
                                    <>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M2 Avg.Mtr</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M2 Avg.Mtr Rate <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                    </>
                                }
                                {formData.m3 &&
                                    <>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M3 Avg.Mtr</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M3 Avg.Mtr Rate <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                    </>
                                }
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Cloth Rate <br /> <span style={{ color: 'red', fontSize: '12px' }}>(Main + Matching)</span></TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Job Rate <br /> <span style={{ color: 'red', fontSize: '12px' }}>(+{formData.jobrate})</span></TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Value of Loss <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.loss}%)`}</span> </TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Extra <br /> <span style={{ color: 'red', fontSize: '12px' }}>(+{formData.extra})</span></TableCell>
                                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Profit</TableCell> */}
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Profit / Final Rate <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.profit}%)`}</span></TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>MRP <br /> <span style={{ color: 'red', fontSize: '12px' }}>65%</span></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sizes ? sizes.map((item, index) => renderTableRow(item, index)) : ''}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default QuotationView;
